import loadScripts from '../utils/loadScripts';
import serverMap from '../../../config/serverMap';
import $x from '../$x';


var wx;
export default {
    isWechat: true,
    async ready() {
        //https://work.weixin.qq.com/api/jsapidemo#closeWindow
        // wx = await import('weixin-sdk-js')
        // alert(wx)
        return wxReady()
    },
    closeWin() {
        wx.closeWindow()
    }
}

async function wxReady() {
    var config = await $x.post('/todo/getWxConfig')
    wx.config({
        debug: false,
        beta: false,
        appId: config.appId,
        timestamp: +new Date(),
        nonceStr: config.nonceStr,
        signature: nonceStr.signature,
        jsApiList: [
            // 'checkJsApi',
            // 'onMenuShareAppMessage',
            // 'onMenuShareWechat',
            // 'onMenuShareTimeline',
            // 'shareAppMessage',
            // 'shareWechatMessage',
            // 'startRecord',
            // 'stopRecord',
            // 'onVoiceRecordEnd',
            // 'playVoice',
            // 'pauseVoice',
            // 'stopVoice',
            // 'uploadVoice',
            // 'downloadVoice',
            // 'chooseImage',
            // 'previewImage',
            // 'uploadImage',
            // 'downloadImage',
            // 'getNetworkType',
            // 'openLocation',
            // 'getLocation',
            // 'hideOptionMenu',
            // 'showOptionMenu',
            // 'hideMenuItems',
            // 'showMenuItems',
            // 'hideAllNonBaseMenuItem',
            // 'showAllNonBaseMenuItem',
            'closeWindow',
            // 'scanQRCode',
            // 'previewFile',
            // 'openEnterpriseChat',
            // 'selectEnterpriseContact',
            // 'onHistoryBack',
            // 'openDefaultBrowser',
        ]
    });
}
